import { useTranslation } from "react-i18next";

// Marketing placeholder — swap in the verified figure when supplied
export const CUSTOMER_COUNT = "25,000+";

const ITEMS = [
  ["Wide choice", "of cars for every journey"],
  ["14", "branches across the UAE"],
  [CUSTOMER_COUNT, "happy customers"],
];

export const TrustStrip = () => {
  const { t } = useTranslation();
  return (
    <section className="bg-[#144733]" data-testid="trust-strip">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6 grid grid-cols-3 gap-4">
        {ITEMS.map(([num, label]) => (
          <div key={label} className="text-center">
            <div className="text-2xl sm:text-3xl font-bold text-[#FFDC00]">{num}</div>
            <div className="text-[10px] sm:text-xs uppercase tracking-widest text-white/75 mt-1">{t(label)}</div>
          </div>
        ))}
      </div>
    </section>
  );
};
